import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import LandingHeader from "../Components/LandingHeader";
import { NavLink } from "react-router-dom";
import InnerFooter from "../Components/InnerFooter";
import Header from "../layout/Header";
import NewFooter from "../layout/Footer";
import { Images } from "../Components/Images";
import { getCMS } from "../actions/settings";
import { useState } from "react";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);





  const [cmsLits, setcmsLits] = useState([]);
  const [value, setValue] = useState()

  const getCMSData = async () => {
    let { status, message, data, count } = await getCMS();
    if (status == "success") {
      setcmsLits(data);
      setValue(data.find((value) => (value.identifier == 'Privacy Policy')))
    }
  };

  useEffect(() => {
    getCMSData();
  }, []);





  return (
    <>
      <div className="common_bgVideo vault_page">
        {/* <img
          src={Images.planlftOvly}
          className="opportunity__lftBlur img-fluid"
        />
        <img
          src={Images.planrytOvly}
          className="opportunity__rightBlur img-fluid"
        /> */}
        <Container
          fluid
          className="p-0 position-relative common_bgg z-3 w-100 h-100"
        >
          <Header />
          <Container fluid className="p-0 custom_container">
            <Container className="home__indexAligner innerpages_ui">
              <div className="plans__holder pb-3 pb-lg-5">
                <h4 className="m-0 hebrew_bold opportunity__title">
                  Privacy Policy
                </h4>

                <div className="cms_contents mt-2 py-2">
                  <p className="paracontent">{value?.content}</p>
                </div>
              </div>
            </Container>
          </Container>
        </Container>
      </div>
      <NewFooter />
    </>
  );
};

export default PrivacyPolicy;
